export const SHADOWS = {
  xs: {
    boxShadow: "0px 1px 2px 0px #1018280D",
    elevation: 1,
    shadowColor: "#101828",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.13,
    shadowRadius: 2,
  },
  sm: {
    boxShadow: "0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)",
    elevation: 1,
    shadowColor: "#101828",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.1,
    shadowRadius: 3,
  },
  md: {
    boxShadow: "0px 4px 8px -2px rgba(16, 24, 40, 0.10), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)",
    elevation: -2,
    shadowColor: "#101828",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.1,
    shadowRadius: 8,
  },
  lg: {
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    elevation: -4,
    shadowColor: "#101828",
    shadowOffset: {
      width: 0,
      height: 12,
    },
    shadowOpacity: 0.08,
    shadowRadius: 16,
  },
  topLg: {
    boxShadow: "0px -12px 16px -4px rgba(16, 24, 40, 0.08), 0px -4px 6px -2px rgba(16, 24, 40, 0.03)", // Sombra no topo
    elevation: -4,
    shadowColor: "#101828",
    shadowOffset: {
      width: 0,
      height: -12,
    },
    shadowOpacity: 0.08,
    shadowRadius: 16,
  },
  xl: {
    boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    elevation: -4,
    shadowColor: "#101828",
    shadowOffset: {
      width: 0,
      height: 20,
    },
    shadowOpacity: 0.08,
    shadowRadius: 24,
  },
  "2xl": {
    boxShadow: "0px 24px 48px -12px rgba(16, 24, 40, 0.18)",
    elevation: -12,
    shadowColor: "#101828",
    shadowOffset: {
      width: 0,
      height: 24,
    },
    shadowOpacity: 0.18,
    shadowRadius: 48,
  },
  "3xl": {
    boxShadow: "0px 32px 64px -12px rgba(16, 24, 40, 0.14)",
    elevation: -12,
    shadowColor: "#101828",
    shadowOffset: {
      width: 0,
      height: 32,
    },
    shadowOpacity: 0.14,
    shadowRadius: 64,
  },
};
